module.exports = __webpack_public_path__ + "static/media/about.513f77be.jpg";